import { TElementId } from "@app/core/constants/element-ids.const";
import { Permission } from "@app/core/permission/enums/permission.enum";

export enum ENavbarItemType {
  Link = 'Link',
  Group = 'Group',
  Header = 'Header',
}

export interface NavbarLink {
  type: ENavbarItemType.Link;
  activePath?: string;
  label: string;
  icon?: string;
  path: string;
  permission?: Permission[];
  /** Optional plugin-module gate (EAppModule value). Hidden when that module is not enabled for the tenant. */
  module?: string;
  excludePaths?: string[];
  elementId?: TElementId;
}

export interface NavbarSectionHeader {
  type: ENavbarItemType.Header;
  label: string;
}

export type TNavbarChild = NavbarLink | NavbarSectionHeader;

export interface NavbarGroup {
  type: ENavbarItemType.Group;
  label: string;
  icon?: string;
  path: string;
  permission?: Permission[];
  /** Optional plugin-module gate (EAppModule value). Hidden when that module is not enabled for the tenant. */
  module?: string;
  children: TNavbarChild[];
  elementId?: TElementId;
}

export type TNavigation = NavbarLink | NavbarGroup;
